import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";
import getDiscountAriaLabel from "./getDiscountAriaLabel";

const ProductDiscountLabel = ({
  labelledById,
  className,
  showDiscountLabel,
  discount
}) =>
  showDiscountLabel && discount ? (
    <div
      id={labelledById}
      aria-label={getDiscountAriaLabel({ discount })}
      aria-hidden={true}
      className={classnames(className, styles.productDiscountLabel)}
    >{`-${discount}%`}</div>
  ) : null;

ProductDiscountLabel.propTypes = {
  labelledById: PropTypes.string.isRequired,
  showDiscountLabel: PropTypes.bool.isRequired,
  discount: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default ProductDiscountLabel;
